// Angular
import { Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
// Layout
import { LayoutConfigService, SplashScreenService, TranslationService } from '../../../core/_base/layout';
// Auth
import { AuthNoticeService } from '../../../core/auth';
import {APP_VERSION} from '../../../core/consts/app-version';
import {TenantService} from '../../../core/tenant/tenant.service';

@Component({
	selector: 'kt-auth',
	templateUrl: './auth.component.html',
	styleUrls: ['./auth.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AuthComponent implements OnInit {
	// Public properties
	today: number = Date.now();
	headerLogo: string;
  currentYear: number;
  appVersion = APP_VERSION;

	/**
	 * Component constructor
	 *
	 * @param el: ElementRef
	 * @param render: Renderer2
	 * @param layoutConfigService: LayoutConfigService
	 * @param authNoticeService: authNoticeService
	 * @param translationService: TranslationService
	 * @param splashScreenService: SplashScreenService
	 */
	constructor(
		private el: ElementRef,
		private render: Renderer2,
		private layoutConfigService: LayoutConfigService,
		public authNoticeService: AuthNoticeService,
		private translationService: TranslationService,
		private splashScreenService: SplashScreenService,
		public tenant: TenantService) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.translationService.setLanguage(this.translationService.getSelectedLanguage());
		this.headerLogo = this.layoutConfigService.getLogo();

		this.splashScreenService.hide();
    this.getCurrentYear();
	}
  getCurrentLanguage() {
    return this.translationService.getSelectedLanguage();
  }
  getLink(type) {
    if (type === 'dataPrivacy') {
      if (this.getCurrentLanguage() === 'en') {
        return 'https://mindfield-shop.com/en/data-protection-declaration/'
      } else {
        return 'https://mindfield-shop.com/datenschutz/';
      }
    }
    if (type === 'about') {
      // No About link on the feelen build at all (see auth.component.html) — Mindfield-only from here on.
      if (this.getCurrentLanguage() === 'en') {
        return 'https://mindfield.de/en/wir-ueber-uns/'
      } else {
        return 'https://mindfield.de/wir-ueber-uns/'
      }
    }
    if (type === 'contact') {
      if (this.tenant.current.id === 'feelen') {
        return 'mailto:neurofeedback@feelen.com';
      }
      if (this.getCurrentLanguage() === 'en') {
        return 'https://mindfield.de/en/kontakt/';
      } else {
        return 'https://mindfield.de/kontakt/';
      }
    }
  }

  getCurrentYear() {
    this.currentYear = new Date().getFullYear();
  }

	/**
	 * Load CSS for this specific page only, and destroy when navigate away
	 * @param styleUrl: any
	 */
	private loadCSS(styleUrl: string) {
		return new Promise((resolve, reject) => {
			const styleElement = document.createElement('link');
			styleElement.href = styleUrl;
			styleElement.type = 'text/css';
			styleElement.rel = 'stylesheet';
			styleElement.onload = resolve;
			this.render.appendChild(this.el.nativeElement, styleElement);
		});
	}
}
